import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { filter } from 'rxjs';

export interface Breadcrumb {
  label: string
  url: string
  path: string
}

@Component({
  selector: 'pixl-breadcrumb',
  imports: [
    MatIconModule,
    RouterLink,
    TranslocoModule,
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
  public router = inject(Router);
  public activatedRoute = inject(ActivatedRoute);
  public breadcrumbs: Breadcrumb[] = [];

  constructor() {
    this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root, '', this.breadcrumbs);

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => {
        this.breadcrumbs = [];
        this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root, '', this.breadcrumbs);
      });
  }

  private createBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: Breadcrumb[]): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const path = child.snapshot.pathFromRoot.map(o => o.url[0]).join('');
      const component = child.snapshot.component;

      // eslint-disable-next-line dot-notation
      breadcrumbs.push({ label: child.snapshot.data['breadcrumb'], url: url, path: ((component && path) ? path : '') });
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
    return breadcrumbs;
  }
}
